import { Match } from "./Match";
import { Competition, Data } from "@gaming/srvg-classes-core";
import { CompetitionStage, COMPETITIONTYPE_CUP, COMPETITIONTYPE_LEAGUE } from "./CompetitionStage";

export class Chunk extends Data {
    /** 1..9 for group phase, 1..6 for cup phase */
    nr: number;
    /**  */
    competition: Competition;
    /** either COMPETITIONTYPE_LEAGUE or COMPETITIOMTYPE_CUP */
    competitionStageType: string;
    /** to match/map in some other models */
    competitionStageTypeId: number;
    /** start timestamp */
    start: number;
    /** betstop timestamp */
    betstop: number;
    /** end timestamp */
    end: number;
    next: Chunk;
    prev: Chunk;

    matches: Match[];

    constructor( nr: number, competitionStageType:string, competition: Competition, matches: Match[], competitionStageTypeId ) {
        super();
        this.nr = nr;
        this.matches = matches;
        this.competitionStageType = competitionStageType;
        this.competitionStageTypeId = competitionStageTypeId;
        this.competition = competition;
        this.start = matches[0] ? matches[0].start : null;
        this.betstop = matches[0] ? matches[0].betstop : null;
        this.end = matches[0] ? matches[0].end : null;
        this.next = null;
        this.prev = null;
        if( ! this.competition ) {
            console.error( 'Chunk without competition created', this );
        }
        if( ! this.matches || ! this.matches.length ) {
            console.error( 'Chunk without matches created', this );
        }
    }

    isEqualTo( chunk: Chunk ) {
        if( !chunk ) {
            return false;
        }
        if( !this.competition ) {
            //console.error( 'I have no competition!', this );
        }
        if( !chunk.competition ) {
            //console.error( 'Chunk has no competition!', chunk );
        }
        return chunk.nr == this.nr && this.competitionStageType == chunk.competitionStageType && (  this.competition === chunk.competition ||  this.competition.isEqualTo( chunk.competition ) );
    }

    isGreaterThan( chunk: Chunk ) {
        if( this.competition.isGreaterThan( chunk.competition ) ) {
            return true;
        }
        if( this.competition.isLessThan( chunk.competition ) ) {
            return false;
        }
        return this.nr > chunk.nr;
    }

    isLessThan( chunk: Chunk ) {
        if( this.competition.isGreaterThan( chunk.competition ) ) {
            return false;
        }
        if( this.competition.isLessThan( chunk.competition ) ) {
            return true;
        }
        return this.nr < chunk.nr;
    }

    length() {
        return this.matches.length; // FIXME count or time?
    }

    destroy() {
        this.competition = null;
        this.competitionStageType = null;
        this.next = null;
        this.prev = null;
    }

    getName() : string {
        if( srvg.chunks ) {
            if( ! this.matches.length ) {
                console.error( 'Error: Chunk has no matches', this );
                return;
            }
            if( ! this.matches[0].chunk_id ) {
                console.error( 'Error: Match has no chunk_id', this.matches[0] );
                return;
            }
            if( ! srvg.chunks[this.matches[0].chunk_id] ) {
                console.error( 'Error: No chunk data found for chunk_id', this.matches[0].chunk_id, 'in', srvg.chunks );
                return;
            }
            var chunkpattern = srvg.chunks[this.matches[0].chunk_id];
            if( chunkpattern.append_matchset_nr ) {
                return __(chunkpattern.chunk_title) + ' ' + this.matches[0].matchset.nr;
            }
            else {
                return __(chunkpattern.chunk_title);
            }
        }
        else {
            var competitionStages = this.getCompetitionStages();
            if( competitionStages.length > 1 /*this.chunk.matches[app.timeline.currentChannel].matchset.competitionStage.stageType == COMPETITIONTYPE_LEAGUE*/ ) {
                return __('MATCH DAY') + ' ' + this.matches[app.timeline.currentChannel].matchset.nr.toString();
            }
            else if( this.matches[app.timeline.currentChannel].matchset.competitionStage.stageType == COMPETITIONTYPE_CUP ) {
                var sporteventSetName = '';
                switch( this.matches[app.timeline.currentChannel].matchset.nr ) {
                    case 3: sporteventSetName = 'Quarterfinal'; break;
                    case 2: sporteventSetName = 'Semifinal'; break;
                    case 1: sporteventSetName = 'Final'; break;
                    default: sporteventSetName = 'Round of ' + Math.pow( 2, this.matches[app.timeline.currentChannel].matchset.nr ); break;
                }
                return __(sporteventSetName);
            }
        }
    }

    getGroups():string[] {
        var competitionStages = this.getCompetitionStages();
        if( competitionStages.length > 1 ) {
            var groups:string[] = [];
            for( var i in competitionStages ) {
                groups.push( String.fromCharCode( 'A'.charCodeAt(0)+competitionStages[i].nr-1 ) );
            }
            return groups;
        }
        else {
            return [];
        }
    }

    getDescription() : string {
        if( srvg.chunks ) {
            if( ! this.matches.length ) {
                console.error( 'Error: Chunk has no matches', this );
                return;
            }
            if( ! this.matches[0].chunk_id ) {
                console.error( 'Error: Match has no chunk_id', this.matches[0] );
                return;
            }
            if( ! srvg.chunks[this.matches[0].chunk_id] ) {
                console.error( 'Error: No chunk data found for chunk_id', this.matches[0].chunk_id, 'in', srvg.chunks );
                return;
            }
            var chunkpattern = srvg.chunks[this.matches[0].chunk_id];
            return __(chunkpattern.chunk_subtitle);
        }
        else {
            var groups = this.getGroups();
            if( groups && groups.length ) {
                var groupName = '';
                if( groups.length == 1 ) {
                    groupName = 'Group' + ' ' + groups[0];
                }
                else if( groups.length == 2 ) {
                    groupName = 'Groups' + ' ' + groups[0] + ' & ' + groups[1];
                }
                else {
                    groupName = 'Groups' + ' ' + groups[0] + '...' + groups[groups.length-1];
                }
                return __(groupName);
            }
            else if( this.matches[app.timeline.currentChannel].matchset.competitionStage.stageType == COMPETITIONTYPE_CUP ) {
                // TODO This feature is finished; check if it should be activated
                /*
                                if( this.prev ) {
                                    var matchset = this.matches[app.timeline.currentChannel].matchset;
                                    var prevMatchset = this.prev.matches[app.timeline.currentChannel].matchset;
                                    if( matchset.id == prevMatchset.id ) {
                                        return __('Part 2');
                                    }
                                }
                                if( this.next ) {
                                    var matchset = this.matches[app.timeline.currentChannel].matchset;
                                    var nextMatchset = this.next.matches[app.timeline.currentChannel].matchset;
                                    if( matchset.id == nextMatchset.id ) {
                                        return __('Part 1');
                                    }
                                }
                */
                return '';
            }
        }
    }

    getCompetitionName() : string {
        var competition = __(this.competition.name);

        // Exception for League Mode, we show SEASON instead of the Mode Name
        if (this.competition.name === "LEAGUE" || this.competition.name === " LEAGUE ITALY") {
            competition = __("Season");
        }


        competition = competition + ' ' + this.competition.nr.toString();

        return competition;
    }


    getCompetitionStages():CompetitionStage[] {
        var competitionStages:CompetitionStage[] = [];
        for( var i in this.matches ) {
            var found = false;
            for( var j in competitionStages ) {
                if( this.matches[i].matchset.competitionStage.id == competitionStages[j].id ) {
                    found = true;
                }
            }
            if( ! found ) {
                competitionStages.push( this.matches[i].matchset.competitionStage );
            }
        }
        return competitionStages;
    }

    /**
     * Calculates and returns the start timestamp of pre_match phase of the current chunk.
     */
    getPreMatchStartTime():number {
        return this.matches[0].betstop-srvg.timelinePhases.pre_match.length;
    }

    /**
     * Calculates and returns the timestamp of the betstop of the previous chunk.
     */
    getPreviousBetstop():number {
        if( this.prev ) {
            // use actual betstop of last matchday
            return this.prev.betstop;
        }
        else {
            // league mode
            if( this.nr == 1 && (srvg.product.mode == "VFLM" || srvg.product.mode == "VFB") ) {
                // calculate approximation of betstop of the last matchday in the last season
                return this.matches[0].betstop -
                    srvg.timelinePhases.pre_match.length -
                    srvg.timelinePhases.pre_league.length -
                    srvg.timelinePhases.post_league.length -
                    srvg.timelinePhases.post_match.length -
                    srvg.timelinePhases.match.length;
            }
            // cup mode, league stage
            else if( this.nr == 1 && this.competitionStageType == COMPETITIONTYPE_LEAGUE ) {
                // calculate approximation of betstop of the last matchday in the last season
                return this.matches[0].betstop -
                    srvg.timelinePhases.pre_match.length -
                    srvg.timelinePhases.pre_cup.length -
                    srvg.timelinePhases.post_cup.length -
                    srvg.timelinePhases.post_match.length -
                    srvg.timelinePhases.match.length;
            }
            // cup mode, cup stage
            else if( this.nr == 1 && this.competitionStageType == COMPETITIONTYPE_CUP ) {
                // calculate approximation of betstop of the last matchday in the previous stage
                return this.matches[0].betstop
                    -srvg.timelinePhases.pre_match.length
                    -srvg.timelinePhases.post_group.length
                    -srvg.timelinePhases.post_match.length
                    -srvg.timelinePhases.match.length;
            }
            else {
                // calculate approximation of betstop of the previous matchday
                return this.matches[0].betstop
                    -srvg.timelinePhases.pre_match.length
                    -srvg.timelinePhases.post_match.length
                    -srvg.timelinePhases.match.length;
            }
        }
    }

    round(): string {
        if( this.competitionStageType == COMPETITIONTYPE_LEAGUE ) {
            return 'group';
        }
        switch( this.matches[app.timeline.currentChannel].matchset.nr ) {
            case 3: return 'quarterfinal';
            case 2: return 'semifinal';
            case 1: return 'final';
            default: return 'round_of_' + Math.pow( 2, this.matches[app.timeline.currentChannel].matchset.nr );
        }
    }

    /**
     *
     * @returns {any}
     */
    roundPart(): number {
        if( srvg.chunks[this.matches[0].chunk_id]['round_part'] ) {
            return srvg.chunks[this.matches[0].chunk_id]['round_part'];
        } else {
            return 0;
        }
    }

    chunkInfo() {
        if( this.matches && this.matches[0] ) {
            return srvg.chunks[this.matches[0].chunk_id];
        }
    }

    chunk_id () {
        if( this.matches && this.matches[0] ) {
            return this.matches[0].chunk_id;
        }
    }
}
